import { useEffect, useState } from "react";
import Categories from "../../components/home/categories";
import Featured from "../../components/home/featured";
import FilterComponent from "../../components/home/filter";
import Listing from "../../components/home/listing";
import Subheading from "../../components/home/subheading";
import Footer from "../../components/layout/footer";
import Header from "../../components/layout/header";
import {
  getAllMachinesCategoryList,
  getAllMachinesMaketList,
  getAllMachinesModelList,
} from "../../services/machineService";
import { ApplicationId } from "../../api/url";
import PageWrapper from "../../components/admin/layouts/PageWrapper/PageWrapper";
import { useMsal } from "@azure/msal-react";

const Home = () => {
  const { instance, accounts } = useMsal();
  const [machinesTypeList, setMachinesTypeList] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);
  //
  const [machinesMakeList, setMachinesMakeList] = useState([]);
  const [makeLoading, setMakeLoading] = useState(false);

  useEffect(() => {
    GetMachinesTypeList();
    GetMachinesMakeList();
  }, []);

  const GetMachinesTypeList = (val) => {
    setCategoryLoading(true);
    getAllMachinesCategoryList()
      .then((res) => {
        setCategoryLoading(false);
        setMachinesTypeList(res?.data);
      })
      .catch((err) => {
        setCategoryLoading(false);
        console.log(err);
      });
  };

  const GetMachinesMakeList = (val) => {
    setMakeLoading(true);
    getAllMachinesMaketList(true)
      .then((res) => {
        setMakeLoading(false);
        setMachinesMakeList(res?.data?.sort((a, b) => a.MakeName.localeCompare(b.MakeName)));
      })
      .catch((err) => {
        setMakeLoading(false);
        console.log(err);
      });
  };

  return (
    <>
      <PageWrapper name="Home">
        <Header />
        <FilterComponent
          List={machinesTypeList}
          isLoader={categoryLoading}
          machinesMakeList={machinesMakeList}
          makeLoading={makeLoading}
        />
        {/* <Featured /> */}
        <Categories List={machinesTypeList} isLoader={categoryLoading} />
        <Listing />
        <Subheading />
        <Footer List={machinesTypeList} isLoader={categoryLoading} />
      </PageWrapper>
    </>
  );
};

export default Home;
